// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.business_dash {
  background-color: #e4ffff;
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}
.business_dash .dashboard_tab {
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.business_dash .dashboard_tab .dashboar_selection_row {
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.business_dash .dashboard_tab .dashboar_selection_row select {
  border: none;
  height: 2rem;
  border-radius: 1rem;
  padding: 5px 10px;
}
.business_dash .dashboard_tab .dashboar_selection_row .date_selection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.business_dash .dashboard_tab .dashboar_selection_row .date_selection input {
  border: none;
  height: 2rem;
  border-radius: 1rem;
  padding: 5px 10px;
  text-align: center;
}
@media (max-width: 600px) {
  .business_dash .dashboard_tab .dashboar_selection_row {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .business_dash .dashboard_tab .dashboar_selection_row select {
    margin-bottom: 2%;
  }
  .business_dash .dashboard_tab .dashboar_selection_row .date_selection {
    margin-bottom: 2%;
  }
  .business_dash .dashboard_tab .dashboar_selection_row .date_selection input {
    width: 85%;
  }
}
.business_dash .dashboard_tab .dashboard_main {
  border-top: 1px solid grey;
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-auto-rows: minmax(100px, auto);
}
.business_dash .dashboard_tab .dashboard_main .apexcharts-canvas {
  background-color: rgb(83, 79, 79);
  border-radius: 30px;
}
.business_dash .dashboard_tab .dashboard_main .apexcharts-legend {
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 5px 0;
  margin: 0 8px 17px 0;
}
.business_dash .dashboard_tab .dashboard_main .apexcharts-legend::-webkit-scrollbar {
  width: 12px;
  background-color: #b0afb0;
  border-radius: 0 10px 10px 0;
}
.business_dash .dashboard_tab .dashboard_main .apexcharts-legend::-webkit-scrollbar-thumb {
  background-color: #f29422;
  border-radius: 0 10px 10px 0;
}
.business_dash .dashboard_tab .dashboard_main .pie_chart_col {
  grid-column: 2/3;
  margin: 0 70px 0 0;
}
.business_dash .dashboard_tab .dashboard_main .totals_table {
  text-align: center;
  margin: 0 auto;
}
.business_dash .dashboard_tab .dashboard_main .totals_table th,
.business_dash .dashboard_tab .dashboard_main .totals_table td {
  font-size: 1.5rem;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table {
  margin: 0 auto 140px;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table,
.business_dash .dashboard_tab .dashboard_main .totals_table {
  grid-column: 1/2;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 90%;
  font-size: 0.9rem;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table td,
.business_dash .dashboard_tab .dashboard_main .waste_category_table th,
.business_dash .dashboard_tab .dashboard_main .totals_table td,
.business_dash .dashboard_tab .dashboard_main .totals_table th {
  border: 1px solid #4d4d4d;
  padding: 5px;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table th,
.business_dash .dashboard_tab .dashboard_main .totals_table th {
  text-align: center;
  background-color: #2c53a0;
  color: white;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table {
  border-collapse: collapse;
  font-size: 0.8rem;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table th,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table th {
  background-color: #f29422;
  color: black;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table td,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table td {
  background-color: white;
  color: black;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table {
  border-collapse: collapse;
  table-layout: fixed;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table th,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table th {
  background-color: #bb0000;
  color: white;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table td,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table td {
  background-color: black;
  color: white;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table tbody .tooltip,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table tbody .tooltip {
  position: relative;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table tbody .tooltip .tooltip_text,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table tbody .tooltip .tooltip_text {
  visibility: hidden;
  width: auto;
  position: absolute;
  z-index: 100;
  text-align: Left;
  opacity: 0.4;
  transition: opacity 2s;
  border-radius: 6px;
  background-color: #8c8c8c;
  color: #fff;
  padding: 3px;
  top: 10px;
  left: 20px;
}
.business_dash .dashboard_tab .dashboard_main .waste_category_table .product_table .damage_table tbody .tooltip:hover .tooltip_text,
.business_dash .dashboard_tab .dashboard_main .totals_table .product_table .damage_table tbody .tooltip:hover .tooltip_text {
  visibility: visible;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.business_dash .dashboard_tab .dashboard_main .dashboard_card_outer {
  width: 21vw;
  height: 10vh;
  margin-inline: auto;
  z-index: 1;
  margin: -25% auto;
}
.business_dash .dashboard_tab .dashboard_main .dashboard_card_outer .card_dash {
  border: 2px solid transparent;
  background: linear-gradient(71deg, #080509, #1a171c, #080509);
  background-clip: padding-box;
  border-radius: 1.5rem;
  padding: 10px;
  position: relative;
}
.business_dash .dashboard_tab .dashboard_main .dashboard_card_outer .card_dash .card_title {
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.02em;
  line-height: 35px;
  font-style: normal;
  font-size: 1.75rem;
  padding-bottom: 8px;
  position: relative;
  text-transform: uppercase;
  text-align: center;
}
.business_dash .dashboard_tab .dashboard_main .dashboard_card_outer .card_dash::after {
  position: absolute;
  top: -2px;
  bottom: -2px;
  left: -2px;
  right: -2px;
  content: "";
  z-index: -1;
  border-radius: 1.5rem;
  background: linear-gradient(71deg, #121013, #b0afb0, #121013);
}
@media (max-width: 1250px) {
  .business_dash .dashboard_tab .dashboard_main .pie_chart_col {
    margin: 0 auto;
    grid-row: 1/2;
    grid-column: 1/3;
  }
  .business_dash .dashboard_tab .dashboard_main .table_container {
    width: 100%;
    margin: 0 0 0 115px;
  }
}

.product_tab {
  margin: 0 auto;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.product_tab .search_card {
  width: 40vw;
  background-color: #fff;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1%;
}
.product_tab .search_card .search_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}
.product_tab .search_card .search_row .search_button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.product_tab .search_card .search_row .search_button input {
  border: 1px solid #2c53a0;
  border-radius: 0.25rem;
}
.product_tab .search_card .filters__shown {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  margin: 3% auto;
}
.product_tab .search_card .filters__shown .filters__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.product_tab .search_card .filters__shown .filters__column label {
  color: #4d4d4d;
  font-size: 0.9rem;
}
.product_tab .search_card .filters__shown .filters__column select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.product_tab .search_card .filters__shown .filters__column input[type=text] {
  width: 80%;
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.product_tab table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 80%;
  margin: 3% auto;
}
.product_tab table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.product_tab table tbody {
  text-align: center;
}
.product_tab table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.product_tab table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.product_tab table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}

.cigs_tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  width: 100vw;
}
.cigs_tab .search_row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 80%;
  margin: 1% auto;
}
.cigs_tab .search_row select {
  border: 1px solid #2c53a0;
  border-radius: 1rem;
  height: 2rem;
}
.cigs_tab .search_row input {
  border: 1px solid #2c53a0;
  border-radius: 0.25rem;
  width: 20%;
}
.cigs_tab table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 60%;
  margin: 1% auto;
}
.cigs_tab table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.cigs_tab table tbody {
  text-align: center;
}
.cigs_tab table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.cigs_tab table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.cigs_tab table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.cigs_tab table tbody tr {
  cursor: pointer;
}
.cigs_tab .product__card {
  background-color: #fff;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 60%;
  margin: 1% auto;
}
.cigs_tab .product__card strong span {
  color: #2c53a0;
}
.cigs_tab .product__card ul {
  color: #2c53a0;
  font-weight: 800;
}
.cigs_tab .product__card ul li span {
  color: #bb0000;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/main_dashboard/dash.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACE,yBDDW;ECEX,iBAAA;EACA,YAAA;EACA,kBAAA;AAIF;AAHE;EAEE,WAAA;ED2DA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACtDJ;AANI;EACE,mBAAA;ED4EF,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ACnEJ;AATM;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAWR;AATM;EDsGF,aAAA;EACA,mBAAA;EACA,uBAAA;AC1FJ;AAZQ;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAcV;AAXM;EApBF;IDyDA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;ECtBF;EAhBM;IACE,iBAAA;EAkBR;EAhBM;IACE,iBAAA;EAkBR;EAjBQ;IACE,UAAA;EAmBV;AACF;AAfI;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;EACA,mCAAA;AAiBN;AAfM;EACE,iCAAA;EACA,mBAAA;AAiBR;AAfM;EACE,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AAiBR;AAfM;EACE,WAAA;EACA,yBAAA;EACA,4BAAA;AAiBR;AAfM;EACE,yBD7DE;EC8DF,4BAAA;AAiBR;AAdM;EACE,gBAAA;EACA,kBAAA;AAgBR;AAbM;EACE,kBAAA;EACA,cAAA;AAeR;AAdQ;;EAEE,iBAAA;AAgBV;AAZM;EACE,oBAAA;AAcR;AAXM;;EAEE,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;AAaR;AAXQ;;;;EAEE,yBAAA;EACA,YAAA;AAeV;AAZQ;;EACE,kBAAA;EACA,yBDxGE;ECyGF,YAAA;AAeV;AAbQ;;EACE,yBAAA;EACA,iBAAA;AAgBV;AAfU;;EACE,yBD1GF;EC2GE,YAAA;AAkBZ;AAfU;;EACE,uBAAA;EACA,YAAA;AAkBZ;AAfU;;EACE,yBAAA;EACA,mBAAA;AAkBZ;AAjBY;;EACE,yBDxHN;ECyHM,YAAA;AAoBd;AAlBY;;EACE,uBAAA;EACA,YAAA;AAqBd;AAlBc;;EACE,kBAAA;AAqBhB;AApBgB;;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAuBlB;AApBkB;;EACE,mBAAA;EACA,UAAA;ED9EhB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ACsGJ;AAjBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;AAmBR;AAlBQ;EACE,6BAAA;EACA,6DAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;AAoBV;AAnBU;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAqBZ;AAnBU;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,6DAAA;AAqBZ;AAhBI;EAEI;IACE,cAAA;IAEA,aAAA;IACA,gBAAA;EAgBR;EAdM;IACE,WAAA;IACA,mBAAA;EAgBR;AACF;;AAVA;EACE,cAAA;EACA,YAAA;EDxJE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACsKJ;AAfE;EACE,WAAA;ED/LA,sBAAA;EAJA,0CAAA;EAMA,mBAAA;EAkCA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EC2JA,WAAA;AAsBJ;AArBI;EDpHA,aAAA;EACA,mBAAA;EACA,8BAAA;ECoHE,UAAA;EACA,cAAA;AAyBN;AAxBM;EDtGF,aAAA;EACA,mBAAA;EACA,2BAAA;ACiIJ;AA3BQ;EACE,yBAAA;EACA,sBAAA;AA6BV;AAzBI;EDvJA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ECsJE,WAAA;EACA,eAAA;AA8BN;AA7BM;EDzKF,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ACyMJ;AAjCQ;EACE,cDnPE;ECoPF,iBAAA;AAmCV;AAjCQ;EACE,yBAAA;EACA,qBAAA;AAmCV;AAjCQ;EACE,UAAA;EACA,yBAAA;EACA,qBAAA;AAmCV;AA9BE;ED9HE,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECoQR,UAAA;EACA,eAAA;AAmCJ;ADhKI;EACI,gCAAA;EACA,kBAAA;ACkKR;ADhKI;EACI,kBAAA;ACkKR;ADjKQ;EACI,gCAAA;ACmKZ;ADlKY;EACI,yBAAA;ACoKhB;ADlKY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACoKhB;;AAjDA;EDxMI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECuMF,cAAA;EACA,YAAA;AAuDF;AAtDE;EDxLE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ECuLA,UAAA;EACA,eAAA;AA2DJ;AA1DI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AA4DN;AA1DI;EACE,yBAAA;EACA,sBAAA;EACA,UAAA;AA4DN;AAzDE;EDxJE,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;EC8RR,UAAA;EACA,eAAA;AA8DJ;ADrNI;EACI,gCAAA;EACA,kBAAA;ACuNR;ADrNI;EACI,kBAAA;ACuNR;ADtNQ;EACI,gCAAA;ACwNZ;ADvNY;EACI,yBAAA;ACyNhB;ADvNY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACyNhB;AA9EM;EACE,eAAA;AAgFR;AA5EE;EDzQE,sBAAA;EAJA,0CAAA;EAMA,mBAAA;EAkCA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECqOA,UAAA;EACA,eAAA;AAmFJ;AAjFM;EACE,cDhTI;ACmYZ;AAhFI;EACE,cDpTM;ECqTN,gBAAA;AAkFN;AAhFQ;EACE,cDpTF;ACsYR","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../variables.scss\";\n\n.business_dash {\n  background-color: $background;\n  min-height: 100vh;\n  width: 100vw;\n  overflow-x: hidden;\n  .dashboard_tab {\n    // margin: 0 auto -20% -2%;\n    width: 90vw;\n    @include columnStart;\n    .dashboar_selection_row {\n      margin: 0 auto 20px;\n      @include rowEven;\n\n      select {\n        border: none;\n        height: 2rem;\n        border-radius: 1rem;\n        padding: 5px 10px;\n      }\n      .date_selection {\n        @include rowCenter;\n        input {\n          border: none;\n          height: 2rem;\n          border-radius: 1rem;\n          padding: 5px 10px;\n          text-align: center;\n        }\n      }\n      @media (max-width: $mobile) {\n        @include columnStart;\n        select {\n          margin-bottom: 2%;\n        }\n        .date_selection {\n          margin-bottom: 2%;\n          input {\n            width: 85%;\n          }\n        }\n      }\n    }\n    .dashboard_main {\n      border-top: 1px solid grey;\n      display: grid;\n      grid-template-columns: 3fr 1fr;\n      grid-auto-rows: minmax(100px, auto);\n\n      .apexcharts-canvas {\n        background-color: rgb(83, 79, 79);\n        border-radius: 30px;\n      }\n      .apexcharts-legend {\n        background-color: rgb(255, 255, 255);\n        border-radius: 10px;\n        padding: 5px 0;\n        margin: 0 8px 17px 0;\n      }\n      .apexcharts-legend::-webkit-scrollbar {\n        width: 12px;\n        background-color: #b0afb0;\n        border-radius: 0 10px 10px 0;\n      }\n      .apexcharts-legend::-webkit-scrollbar-thumb {\n        background-color: $warning;\n        border-radius: 0 10px 10px 0;\n      }\n\n      .pie_chart_col {\n        grid-column: 2/3;\n        margin: 0 70px 0 0;\n      }\n\n      .totals_table {\n        text-align: center;\n        margin: 0 auto;\n        th,\n        td {\n          font-size: 1.5rem;\n        }\n      }\n\n      .waste_category_table {\n        margin: 0 auto 140px;\n      }\n\n      .waste_category_table,\n      .totals_table {\n        grid-column: 1/2;\n        font-family: Arial, Helvetica, sans-serif;\n        border-collapse: collapse;\n        width: 90%;\n        font-size: 0.9rem;\n\n        td,\n        th {\n          border: 1px solid $fontColor;\n          padding: 5px;\n        }\n\n        th {\n          text-align: center;\n          background-color: $nitroDark;\n          color: white;\n        }\n        .product_table {\n          border-collapse: collapse;\n          font-size: 0.8rem;\n          th {\n            background-color: $warning;\n            color: black;\n          }\n\n          td {\n            background-color: white;\n            color: black;\n          }\n\n          .damage_table {\n            border-collapse: collapse;\n            table-layout: fixed;\n            th {\n              background-color: $error;\n              color: white;\n            }\n            td {\n              background-color: black;\n              color: white;\n            }\n            tbody {\n              .tooltip {\n                position: relative;\n                .tooltip_text {\n                  visibility: hidden;\n                  width: auto;\n                  position: absolute;\n                  z-index: 100;\n                  text-align: Left;\n                  opacity: 0.4;\n                  transition: opacity 2s;\n                  border-radius: 6px;\n                  background-color: #8c8c8c;\n                  color: #fff;\n                  padding: 3px;\n                  top: 10px;\n                  left: 20px;\n                }\n                &:hover {\n                  .tooltip_text {\n                    visibility: visible;\n                    opacity: 1;\n                    @include columnAlignStart;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .dashboard_card_outer {\n        width: 21vw;\n        height: 10vh;\n        margin-inline: auto;\n        z-index: 1;\n        margin: -25% auto;\n        .card_dash {\n          border: 2px solid transparent;\n          background: linear-gradient(71deg, #080509, #1a171c, #080509);\n          background-clip: padding-box;\n          border-radius: 1.5rem;\n          padding: 10px;\n          position: relative;\n          .card_title {\n            font-weight: 600;\n            color: #fff;\n            letter-spacing: -0.02em;\n            line-height: 35px;\n            font-style: normal;\n            font-size: 1.75rem;\n            padding-bottom: 8px;\n            position: relative;\n            text-transform: uppercase;\n            text-align: center;\n          }\n          &::after {\n            position: absolute;\n            top: -2px;\n            bottom: -2px;\n            left: -2px;\n            right: -2px;\n            content: \"\";\n            z-index: -1;\n            border-radius: 1.5rem;\n            background: linear-gradient(71deg, #121013, #b0afb0, #121013);\n          }\n        }\n      }\n    }\n    @media (max-width: 1250px) {\n      .dashboard_main {\n        .pie_chart_col {\n          margin: 0 auto;\n\n          grid-row: 1/2;\n          grid-column: 1/3;\n        }\n        .table_container {\n          width: 100%;\n          margin: 0 0 0 115px;\n        }\n      }\n    }\n  }\n}\n\n.product_tab {\n  margin: 0 auto;\n  width: 100vw;\n  @include columnStart;\n  .search_card {\n    width: 40vw;\n    @include card;\n    @include columnStart;\n    padding: 1%;\n    .search_row {\n      @include rowBetween;\n      width: 90%;\n      margin: 0 auto;\n      .search_button {\n        @include rowStart;\n        input {\n          border: 1px solid $nitroDark;\n          border-radius: 0.25rem;\n        }\n      }\n    }\n    .filters__shown {\n      @include rowEven;\n      width: 100%;\n      margin: 3% auto;\n      .filters__column {\n        @include columnAlignStart;\n        label {\n          color: $fontColor;\n          font-size: 0.9rem;\n        }\n        select {\n          border: 1px solid $nitroDark;\n          border-radius: 0.5rem;\n        }\n        input[type=\"text\"] {\n          width: 80%;\n          border: 1px solid $nitroDark;\n          border-radius: 0.5rem;\n        }\n      }\n    }\n  }\n  table {\n    @include table;\n    width: 80%;\n    margin: 3% auto;\n  }\n}\n\n.cigs_tab {\n  @include columnStart;\n  margin: 0 auto;\n  width: 100vw;\n  .search_row {\n    @include rowEven;\n    width: 80%;\n    margin: 1% auto;\n    select {\n      border: 1px solid $nitroDark;\n      border-radius: 1rem;\n      height: 2rem;\n    }\n    input {\n      border: 1px solid $nitroDark;\n      border-radius: 0.25rem;\n      width: 20%;\n    }\n  }\n  table{\n    @include table;\n    width: 60%;\n    margin: 1% auto;\n    tbody{\n      tr{\n        cursor: pointer;\n      }\n    }\n  }\n  .product__card{\n    @include card;\n    @include columnStart;\n    width: 60%;\n    margin: 1% auto;\n    strong{\n      span{\n        color: $nitroDark;\n      }\n    }\n    ul{\n      color: $nitroDark;\n      font-weight: 800;\n      li{\n        span{\n          color: $error;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
